import * as React from 'react';
const SvgDataTransfer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.489 2.178a.75.75 0 1 0-1.06 1.06l2.052 2.054H2.709a.75.75 0 1 0 0 1.5H15.48l-2.053 2.053a.75.75 0 0 0 1.06 1.06l3.334-3.333a.75.75 0 0 0 0-1.06zM6.572 11.155 4.52 13.21h12.773a.75.75 0 0 1 0 1.5H4.519l2.053 2.052a.75.75 0 0 1-1.06 1.061l-3.334-3.333a.75.75 0 0 1 0-1.061l3.334-3.333a.75.75 0 1 1 1.06 1.06"
    />
  </svg>
);
export default SvgDataTransfer;
